import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import WordTable from './WordTable.js';

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}



export default function WordListDialog(props) {
  // console.log("wordlist len", props.currentWordList.length)
  return (
    <div>
      <Dialog fullWidth
        onClose={props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={props.handleClose}>
          {props.dialogTitle}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <WordTable currentWordList={props.currentWordList} sm={props.sm} setSelectionModel={props.setSelectionModel} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={props.saveFromDialog}>
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}